import toast from 'react-hot-toast';
import { FieldValues, Path, UseFormSetError } from 'react-hook-form';
import { INCOMPLETE_ADDRESS_MESSAGE } from '../constants/address';
import { AddressParts, isCompleteAddress } from './AddressUtils';

/**
 * The last check before an address step calls the API.
 *
 * Returns true when the submit has to stop: the address is missing a part the backend requires, and
 * the customer has been told. The error goes on the search bar, where autocomplete mode shows it
 * and clears it on the next submit; the toast is what shows in either mode.
 *
 * In manual mode every field carries its own rule (see `requireCompleteAddress` on
 * `FlexibleAddressInput`), so this never fires there: an error set on the search bar while it is
 * not registered is one the form library never re-checks, and it would block every later submit.
 */
export const rejectIncompleteAddress = <TForm extends FieldValues>(
  parts: Partial<Record<keyof AddressParts, unknown>>,
  setError: UseFormSetError<TForm>,
  searchFieldName: Path<TForm>
): boolean => {
  if (isCompleteAddress(parts)) return false;

  setError(searchFieldName, {
    type: 'incompleteAddress',
    message: INCOMPLETE_ADDRESS_MESSAGE,
  });
  toast.error(INCOMPLETE_ADDRESS_MESSAGE);
  return true;
};
